import { render, staticRenderFns } from "./Cabinet.vue?vue&type=template&id=6ad5f124&scoped=true&"
import script from "./Cabinet.vue?vue&type=script&lang=js&"
export * from "./Cabinet.vue?vue&type=script&lang=js&"
import style0 from "./Cabinet.vue?vue&type=style&index=0&id=6ad5f124&prod&lang=scss&scoped=true&"
import style1 from "./Cabinet.vue?vue&type=style&index=1&id=6ad5f124&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad5f124",
  null
  
)

export default component.exports